import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useStyles(env, client) {
  const [loadedStyles, setLoadedStyles] = useState(false);
  const [styles, setStyles] = useState(null);

  useEffect(() => {
    setLoadedStyles(false);
    if (!client || !env) {
      setLoadedStyles(true);
      return;
    }
    const ref = collection(db, "kiosk", env, "client", client, "config");
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = {};
      snapshot.docs.forEach((doc) => {
        data[doc.id] = {
          id: doc.id,
          ...doc.data()
        };
      });
      setStyles(data);
      setLoadedStyles(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedStyles, styles };
}